import { logger } from 'monitor';
import { createObjectUrl, revokeObjectUrl } from '../../../files';

export const isAspectRatioValid = (photo: File, minAspectRatio: number) => {
  const image = new Image();
  const photoUrl = createObjectUrl(photo);
  image.src = photoUrl;

  return new Promise<boolean>((resolve) => {
    const cleanup = () => {
      image.onload = null;
      image.onerror = null;
      revokeObjectUrl(photoUrl);
    };

    image.onload = () => {
      logger.debug('validating aspect ratio', {
        height: image.height,
        minAspectRatio,
        width: image.width,
      });

      const isPortrait = image.height > image.width;
      if (isPortrait) {
        const aspectRatio = image.width / image.height;
        logger.debug('aspectRatio :', { aspectRatio, minAspectRatio });
        cleanup();
        resolve(aspectRatio >= minAspectRatio);
        return;
      }
      const aspectRatio = image.height / image.width;
      logger.debug('aspectRatio :', { aspectRatio, minAspectRatio });
      cleanup();
      resolve(aspectRatio >= minAspectRatio);
    };

    image.onerror = () => {
      cleanup();
      resolve(false);
    };
  });
};
